import {combineReducers} from "redux";

import appsetup from "../features/admin/customizations/appsetup/Slice";

import office from "../features/admin/customizations/office_location/Slice";

import common from "../features/admin/common/Slice";

const customizations = combineReducers({
    appsetup,
    office,
    common
});

export default customizations;